import { QueryClient } from "@tanstack/react-query";

const NO_RETRY_STATUS = [400, 401, 403, 404, 422];

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 3) return false;
  if (error && typeof error === "object" && "status" in error) {
    const status = (error as { status?: number }).status;
    if (typeof status === "number" && NO_RETRY_STATUS.includes(status)) return false;
  }
  return true;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,
      gcTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: shouldRetry,
      retryDelay: (failureCount) => Math.min(1000 * 2 ** failureCount, 30000),
    },
    mutations: { retry: 0 },
  },
});
